import type { AdminProduct } from '@popcart/core/v1';
import { StatusPill } from '../ui/bits';
import { Icon } from '../ui/Icon';
import { reviewBadge, reviewExplainer, type ReviewFields } from './lib/review.js';
import { photoBadge, type PhotoFields } from './lib/photo-rule.js';

/** "In review" / "Not approved: {note}" on a product (Phase 7 catalogue review). Nothing when approved. */
export function ReviewBadge({ product }: { product: AdminProduct & ReviewFields }) {
  const b = reviewBadge(product);
  if (!b) return null;
  return (
    <span className="cat-review" data-review={b.tone === 'warning' ? 'pending' : 'rejected'}>
      <StatusPill tone={b.tone}>{b.label}</StatusPill>
    </span>
  );
}

/** The editor's line under the header explaining what review means for this product. */
export function ReviewNote({ product }: { product: AdminProduct & ReviewFields }) {
  const text = reviewExplainer(product);
  if (!text) return null;
  return (
    <div className="note row cat-review-note" role="status">
      <Icon name="alert" />
      <span className="grow t-label">{text}</span>
    </div>
  );
}

/** "Needs a photo" (0013: every product shows a real photo; the drawing stays the thumbnail). Same badge style as review. */
export function PhotoBadge({ product }: { product: PhotoFields }) {
  const b = photoBadge(product);
  if (!b) return null;
  return (
    <span className="cat-review" data-photo="missing">
      <StatusPill tone={b.tone}>{b.label}</StatusPill>
    </span>
  );
}
